import { SkinSelector } from '../../propertyPanel/CommonProperties/SkinSelector';

/**
 * 주문 내역 컴포넌트 속성 정의
 * 에디터의 속성 패널에서 사용할 속성 그룹 및 컨트롤 정의
 */
const OrderHistoryProperties = [
  {
    group: '외부 스킨',
    icon: 'palette',
    properties: [
      {
        name: 'componentProps.skin',
        label: '스킨 선택',
        control: SkinSelector,
        defaultValue: 'basic'
      }
    ]
  },
  {
    group: '기본 설정',
    properties: [
      {
        name: 'componentProps.title',
        label: '제목',
        control: 'TextField',
        defaultValue: '주문 내역'
      },
      {
        name: 'componentProps.emptyText',
        label: '주문 내역 없음 메시지',
        control: 'TextField',
        defaultValue: '주문 내역이 없습니다.'
      }
    ]
  },
  {
    group: '스타일',
    properties: [
      {
        name: 'style.backgroundColor',
        label: '배경색',
        control: 'ColorPicker',
        defaultValue: '#f9f9fb'
      },
      {
        name: 'style.padding',
        label: '패딩',
        control: 'TextField',
        defaultValue: '40px 0'
      },
      {
        name: 'componentProps.className',
        label: 'CSS 클래스',
        control: 'TextField',
        defaultValue: 'order-history-wrapper padding-tb-40'
      }
    ]
  }
];

export default OrderHistoryProperties; 